import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import Heading from '@bibliocommons/heading';

import ResourcesList from 'app/components/bibs/shared/ResourcesList';
import { onlineResourceShape } from 'app/shapes/bibPage';

export default function OnlineResources({ onlineResources, handleClick }) {
  if (onlineResources.size === 0) return null;

  return (
    <div className="cp-online-resources">
      <Heading tagName="h3" size="medium" variant>
        <FormattedMessage id="online_resources" />
      </Heading>
      <ResourcesList resources={onlineResources} handleClick={handleClick} />
    </div>
  );
}

OnlineResources.propTypes = {
  handleClick: PropTypes.func.isRequired,
  onlineResources: ImmutablePropTypes.listOf(onlineResourceShape).isRequired
};
